<template>
  <div class="generalFieldItem" >
    <el-popover
          ref="popoverTargetRef"
          width="auto"
          popper-class="customTerm-popover"
          placement="bottom-start"
          trigger="click"
      >
      <template #reference>
        <div class="el-dropdown-term">
          <div style="font-size: 13px; font-weight: bold; color: #8C8C8C;" v-if="Object.keys(currentField).length == 0">
            {{$t("homePagePleaseChoose")}}
          </div>
          <div v-if="Object.keys(currentField).length > 0">
            <div class="select-title">{{ currentField.name }}</div>
          </div>
          <el-icon class="el-icon--right" style="font-size: 13px; font-weight: bold; color: #8C8C8C;">
            <arrow-down />
          </el-icon>
        </div>
      </template>
      <div class="generalField-body">
        <div class="generalField-item" v-for="item in currentFields" :key="item.id" @click="onSelectField(item)">
          <div class="generalField-item-title" :class="{'generalField-item-title-active': currentField.id == item.id}">{{ item.name }}</div>
          <div class="generalField-item-icon" v-if="currentField.id == item.id">
            <i class="iconfont icon-icon_correct"/>
          </div>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script setup lang="ts">
import {defineEmits, watch} from "vue";
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import useUserStore from "@/store/modules/user";
import basicUserStore from "@/store/modules/basic";
import {storeToRefs} from "pinia";
import { ArrowDown } from '@element-plus/icons-vue'
import eventBus from 'vue3-eventbus'
import { useRouter, useRoute } from 'vue-router'
import Toast from "@/utils/toast";

const userStore = useUserStore();
const basicStore = basicUserStore();
const router = useRouter()
const route = useRoute()
const popoverTargetRef = ref()
let call = defineEmits(["onUpdataField", "onUpPro",'onClose'])

const {token} = storeToRefs(userStore);
const {languages} = storeToRefs(basicStore);

interface Props {
  promptType?: number
}
const props = defineProps<Props>()

const currentFields = ref([{
  id: 1,
  name: t('general_field'),
}, {
  id: 2,
  name: t('general_field_paper'),
}, {
  id: 3,
  name: t('general_field_law'),
}, {
  id: 4,
  name: t('general_field_commercial'),
}])

const currentField = ref({})

watch(
    () => languages.value,
    () => {
      if (languages.value.length > 0) {
        currentFields.value = [{
          id: 1,
          name: t('general_field'),
        }, {
          id: 2,
          name: t('general_field_paper'),
        }, {
          id: 3,
          name: t('general_field_law'),
        }, {
          id: 4,
          name: t('general_field_commercial'),
        }]
      }
    },
    {
      deep: true
    }
)

watch(
  () => props.promptType,
  (newValue, oldValue) => {
    console.log('promptType', newValue)
    if (oldValue != newValue ) {
      currentFields.value = [{
        id: 1,
        name: t('general_field'),
      }, {
        id: 2,
        name: t('general_field_paper'),
      }, {
        id: 3,
        name: t('general_field_law'),
      }, {
        id: 4,
        name: t('general_field_commercial'),
      }]
      currentField.value = currentFields.value.find(item => item.id == newValue) || {}
    }
  }
)

function onUpPro(){
  console.log("onUpPro")
  call('onUpPro')
}

function onSelectField(item) {
  if (!token.value) {
    onUpPro()
    return
  }
  currentField.value = item
  call('onUpdataField', item)
  popoverTargetRef.value && popoverTargetRef.value.hide()
}

onMounted(()=>{
  currentFields.value = [{
    id: 1,
    name: t('general_field'),
  }, {
    id: 2,
    name: t('general_field_paper'),
  }, {
    id: 3,
    name: t('general_field_law'),
  }, {
    id: 4,
    name: t('general_field_commercial'),
  }]
  if (props.promptType) {
    currentField.value = currentFields.value.find(item => item.id == props.promptType) || {}
  }
})

</script>

<style lang="scss">
.generalFieldItem {
  display: flex;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
}
.generalField-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
  flex-wrap: wrap;
}
.generalField-item {
  min-width: 200px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  // .screen-lg({
  //   width:500px;
  // });
  // .screen-md({
  //   width:400px;
  // });
  // .screen-sm({
  //   width:300px;
  // });
  // .screen-xs({
  //   width:300px;
  // });
  .generalField-item-title {
    font-size: 14px;
    color: var(--text-color1);
  }
  .generalField-item-title-active {
    color: var(--progress-bg-color);
  }
  &:hover .generalField-item-title {
    color: var(--progress-bg-color);
  }
  .generalField-item-icon {
    .icon-icon_correct {
      color: var(--progress-bg-color);
      font-size: 18px;
    }
  }
}

.el-dropdown-term {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  width: 100%;
}
input::placeholder {
  color: #BFBFBF; /* 设置placeholder颜色为橙色 */
}

.select-title {
  color: #262626;
  font-size: 13px;
}
.custom-tag .el-icon-close {
  color: #BFBFBF; /* hover 状态下的颜色 */
}
.custom-tag .el-icon-close:hover {
  color: #BFBFBF; /* hover 状态下的颜色 */
}


</style>
<style scss scoped>
.termListItem input{
  font-size: 16px !important;
}

.customTerm-popover.el-popover{
  background-color: #FFFFFF !important;
  border-color: transparent !important;
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.16);
  max-height: 300px;
  .el-popper__arrow::before {
    background: #FFFFFF;
    border-color: transparent;
  }
}

</style>

<style scoped>
.no-border-input :deep(.el-input__wrapper) {
  box-shadow: none !important; /* 清除边框 */
  border: none !important; /* 确保没有边框 */
}

.no-border-input :deep(.el-input__wrapper:hover) {
  box-shadow: none !important; /* 清除 hover 状态下的边框 */
}

.no-border-input :deep(.el-input__wrapper.is-focus) {
  box-shadow: none !important; /* 清除聚焦状态下的边框 */
}

</style>